module.exports = __webpack_public_path__ + "static/media/30-8.f96cda98.mp3";